import React from 'react';

import { ALLOWED_ROLES, REMOTE_CONFIG_KEYS, withRemoteConfigKey } from '@src/packages/utils';

import WorkJourneyRouteWrapper from './components/WorkJourneyRouteWrapper';
import { PATHS } from './constants';
import WorkJourney from './screens/WorkJourney';
import WorkJourneyCreate from './screens/WorkJourneyCreate';
import WorkJourneyEdit from './screens/WorkJourneyEdit';
import WorkJourneyRealTime from './screens/WorkJourneyRealTime';
import { WorkJourneyManagement } from './screens/WorkJourneyManagement';
import { WorkJourneyMonthMatrix } from './screens/WorkJourneyMonthMatrix';

/**
 * Routes for WorkJourney
 */
const routes = [
  {
    component: (props: Record<string, unknown>) => (
      <WorkJourneyRouteWrapper component={WorkJourneyRealTime} routeProps={props} />
    ),
    path: PATHS.REAL_TIME,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_JOURNEY.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.REAL_TIME}`,
  },
  {
    component: (props: Record<string, unknown>) => (
      <WorkJourneyRouteWrapper component={WorkJourney} routeProps={props} />
    ),
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_JOURNEY.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: (props: Record<string, unknown>) => (
      <WorkJourneyRouteWrapper component={WorkJourneyCreate} routeProps={props} />
    ),
    path: PATHS.CREATE_WORK_JOURNEY,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_JOURNEY.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: (props: Record<string, unknown>) => (
      <WorkJourneyRouteWrapper component={WorkJourneyEdit} routeProps={props} />
    ),
    path: PATHS.EDIT_WORK_JOURNEY,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_JOURNEY.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: WorkJourneyMonthMatrix,
    path: PATHS.WORK_JOURNEY_MONTH_MATRIX,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_JOURNEY.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.WORK_JOURNEY_MANAGEMENT}`,
  },
  {
    component: WorkJourneyManagement,
    path: PATHS.WORK_JOURNEY_MANAGEMENT,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.WORK_JOURNEY.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.WORK_JOURNEY_MANAGEMENT}`,
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.TIME_TRACKER, routes);
